// removed by extract-text-webpack-plugin
module.exports = {"menuItemIcon":"unBnXq_xtCctDFQg"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Common/Menu/MenuItemIcon.pcss
// module id = 475
// module chunks = 1